export default "__VITE_ASSET__usemRTSM__"